import React, { useRef, useState } from "react";
import dropDown from "./images/drop-down-accordian.svg";
import whistleIcon from "./images/whistle-icon.svg";
import structureIcon from "./images/structure-icon.svg";
import dumbelIcon from "./images/dumbell-icon.svg";
import soccerIcon from "./images/soccer-field-icon.svg";
import rxLogo from "./images/RX-ca-logo.png";
import billyImg from "./images/rx-earnest-billy.png";
import rxMuraliImg from "./images/rx-murali.png";
import mamthaImg from "./images/rx-mamatha-maben.png";
import prateekImg from "./images/rx-prateek.png";
import "./styles.css";

const Accordion = () => {
  const contentRef = useRef(null);
  const [open, setOpen] = useState(false);

  return (
    <section
      className={`box-shadow-card ml-96 mr-96 mt-48 accordion-section ${
        open ? "active" : ""
      }`}
    >
      {/* TOGGLE */}
      <div
        className="flex center-align space-bw accordion-toggle"
        onClick={() => setOpen(!open)}
      >
        <div>
          <h2 className="train-best">What makes RX different ?</h2>
        </div>
        <div>
          <img src={dropDown} alt="drop-down" className="accordion-icon" />
        </div>
      </div>

      {/* COLLAPSIBLE CONTENT */}
      <div
        ref={contentRef}
        className="accordion-content"
        style={{
          maxHeight: open ? `${contentRef.current?.scrollHeight}px` : "0px",
        }}
      >
        <div className="flex flex-wrap mt-32">
          <div className="flex center-align mb-32">
            <img className="mr-16" src={whistleIcon} alt="whistle-icon" />
            <span className="mr-32 why-text">
              Personalized coaching for ages 5 - 25
            </span>
          </div>

          <div className="vertical-border"></div>

          <div className="flex center-align mb-32">
            <img className="mr-16" src={structureIcon} alt="dumbell-icon" />
            <span className="mr-32 why-text">
              Structured pathways from beginner to advanced
            </span>
          </div>

          <div className="vertical-border"></div>

          <div className="flex center-align mb-32">
            <img className="mr-16" src={dumbelIcon} alt="skill-up-icon" />
            <span className="mr-32 why-text">
              Performance-focused training with cricket + fitness balance
            </span>
          </div>

          <div className="vertical-border"></div>

          <div className="flex center-align mb-32">
            <img className="mr-16" src={soccerIcon} alt="cricket-icon" />
            <span className="mr-32 why-text">
              Astro-turf wickets, bowling machines, cutting-edge training aids
            </span>
          </div>
        </div>

        <div className="flex flex-col mt-32">
          <div>
            <h2 className="train-best">
              Coaches: Rx Murali, Earnest Billy, Mamatha Maben, Prateek
            </h2>
          </div>
          <p className="why-text mt-16">Flexible Weekday & Weekend slots</p>
        </div>

        <div className="hr-line-two"></div>

        <div className="image-container-grid mt-48">
          <div className="flex center-align justify-center-mob">
            <img className="vpcc-logo-two" src={rxLogo} alt="vpcc-logo" />
          </div>

          <div className="coach-card">
            <div className="coach-img">
              <img src={rxMuraliImg} alt="RX Murali" />
            </div>
            <div className="coach-info">
              <h3>RX Murali</h3>
              <p>
                Renowned Cricket Speed & Skill Coach for over 20 years. Trained
                top Indian cricketers including KL Rahul, Dinesh Karthik, and
                Washington Sundar. Former Head Coach – MRF Pace Foundation.
                Certified BCCI Level 3 & ICC Coach
              </p>
            </div>
          </div>

          <div className="coach-card">
            <div className="coach-img">
              <img src={billyImg} alt="Earnest Billy" />
            </div>
            <div className="coach-info">
              <h3>Earnest Billy</h3>
              <p>
                Level 2 Certified Coach | 10+ Years Experience Former Head Coach
                - Dubai Capitals Academy & High Performance Academy (Bahrain).
                Worked with world-renowned coach Dav Whatmore for 3 years in
                Chennai Played professional leagues in Chennai & Bahrain
              </p>
            </div>
          </div>

          <div className="flex align-end display-non-mob">
            <a
              href="https://rzp.io/rzp/WKvOrKth"
              target="_blank"
              rel="noreferrer"
              onClick={() => {
                window.fbq("track", "Subscribe", {
                  academy: "VPCC x RX Cricket Academy",
                });
              }}
            >
              <button className="primary-btn link-pd-2">
                Book your Trial at ₹99
              </button>
            </a>
          </div>

          <div className="coach-card">
            <div className="coach-img">
              <img src={mamthaImg} alt="Mamatha Maben" />
            </div>
            <div className="coach-info">
              <h3>Mamatha Maben</h3>
              <p>
                Former captain Indian women’s team BCCI level 2 coach Coached
                china, bangaladesh and Namibia
              </p>
            </div>
          </div>

          <div className="coach-card">
            <div className="coach-img">
              <img src={prateekImg} alt="RX Prateek" />
            </div>
            <div className="coach-info">
              <h3>Prateek</h3>
              <p>
                ICC Level 2 certified coach with 7+ years’ experience at RX
                Cricket Academy. Has trained players like Mayank Agarwal, Dinesh
                Karthik, and Mithali Raj, with 17 students representing zonal
                teams.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accordion;
